import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  generateItem,
} from "./licenseAPI";

const initialState = {
  data: [],
  dataCompany: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "license/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchLicense = createAsyncThunk(
  "license/fetchLicense",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchId = createAsyncThunk("license/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "license/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("license/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const generateLicense = createAsyncThunk(
  "license/generateLicense",
  async (payload) => {
    const response = await generateItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk(
  "license/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "license/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchLicense.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchLicense.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(generateLicense.pending, (state) => {
        state.loading = true;
      })
      .addCase(generateLicense.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = licenseSlice.actions;

export const selectData = (state) => state.license.data;
export const selectDataLicense = (state) => state.license.data;
export const selectDataAllCompany = (state) => state.license.dataCompany;
export const selectId = (state) => state.license.dataId;
export const selectLoading = (state) => state.license.loading;
export const selectError = (state) => state.license.error;
export const selectPageNo = (state) => state.license.pageNo;
export const selectPageSize = (state) => state.license.pageSize;
export const selectTotalRecord = (state) => state.license.totalRecord;
export const selectSelected = (state) => state.license.selected;
export const selectResult = (state) => state.license.result;

export default licenseSlice.reducer;
